import { Action } from '@ngrx/store';
import { VatIdResponseModel } from '~app/modules/checkout/models/vat-id-response.model';

import { Address, Order } from '../../models';

export enum OrderActionTypes {
  CREATE_ORDER = '[app-checkout/Checkout] Create order',
  CREATE_ORDER_SUCCESS = '[app-checkout/Checkout] Create order Success',
  CREATE_ORDER_FAILURE = '[app-checkout/Checkout] Create order Failure',

  UPDATE_ORDER = '[app-checkout/Checkout] Update order',
  UPDATE_ORDER_SUCCESS = '[app-checkout/Checkout] Update order Success',
  UPDATE_ORDER_FAILURE = '[app-checkout/Checkout] Update order Failure',

  CHECK_VAT_ID_VALIDITY = '[app-checkout/Checkout] Check vat id validity',
  CHECK_VAT_ID_VALIDITY_SUCCESS = '[app-checkout/Checkout] Check vat id validity Success',
  CHECK_VAT_ID_VALIDITY_FAILURE = '[app-checkout/Checkout] Check vat id validity Failure',
}

export class CreateOrder implements Action {
  readonly type = OrderActionTypes.CREATE_ORDER;
  constructor(public payload: { shippingAddress: Address; billingAddress: Address }) {}
}

export class CreateOrderSuccess implements Action {
  readonly type = OrderActionTypes.CREATE_ORDER_SUCCESS;
  constructor(public payload: Order) {}
}

export class CreateOrderFailure implements Action {
  readonly type = OrderActionTypes.CREATE_ORDER_FAILURE;
  constructor(public payload: any) {}
}

export class UpdateOrder implements Action {
  readonly type = OrderActionTypes.UPDATE_ORDER;
  constructor(public payload: { freightForwardPhone: string; orderId: string }) {}
}

export class UpdateOrderSuccess implements Action {
  readonly type = OrderActionTypes.UPDATE_ORDER_SUCCESS;
  constructor(public payload: Order) {}
}

export class UpdateOrderFailure implements Action {
  readonly type = OrderActionTypes.UPDATE_ORDER_FAILURE;
  constructor(public payload: any) {}
}

export class CheckVatIdValidity implements Action {
  readonly type = OrderActionTypes.CHECK_VAT_ID_VALIDITY;
  constructor(public payload: { orderNumber: string }) {}
}

export class CheckVatIdValiditySuccess implements Action {
  readonly type = OrderActionTypes.CHECK_VAT_ID_VALIDITY_SUCCESS;
  constructor(public payload: boolean) {}
}

export class CheckVatIdValidityFailure implements Action {
  readonly type = OrderActionTypes.CHECK_VAT_ID_VALIDITY_FAILURE;
  constructor(public payload: any) {}
}

export type OrderActions =
  | CreateOrder
  | CreateOrderSuccess
  | CreateOrderFailure
  | UpdateOrder
  | UpdateOrderSuccess
  | UpdateOrderFailure
  | CheckVatIdValidity
  | CheckVatIdValiditySuccess
  | CheckVatIdValidityFailure;
